import { render, staticRenderFns } from "./LeaveList.vue?vue&type=template&id=70bc7048&"
import script from "./LeaveList.vue?vue&type=script&lang=js&"
export * from "./LeaveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports